import InputsForm from './InputsForm';

export default InputsForm;
